import type { WatermarkConfig } from "@family/shared";

interface WatermarkProps {
  config: WatermarkConfig;
  variables: {
    user: string;
    family: string;
    phone?: string | null;
    email?: string | null;
  };
}

const POSITION_STYLES: Record<
  WatermarkConfig["position"],
  React.CSSProperties
> = {
  "top-left": { top: 8, left: 8 },
  "top-right": { top: 8, right: 8 },
  "bottom-left": { bottom: 8, left: 8 },
  "bottom-right": { bottom: 8, right: 8 },
  center: { top: "50%", left: "50%", transform: "translate(-50%, -50%)" },
};

function substitute(
  template: string,
  vars: Record<string, string | null | undefined>,
): string {
  return template.replace(/\{(\w+)\}/g, (_, name) => {
    const v = vars[name];
    return v == null ? "" : String(v);
  });
}

export function Watermark({ config, variables }: WatermarkProps) {
  if (!config.enabled) return null;
  const text = substitute(config.text, {
    user: variables.user,
    family: variables.family,
    phone: variables.phone ?? "",
    email: variables.email ?? "",
  }).trim();

  if (!text) return null;

  return (
    <div
      className="watermark"
      aria-hidden="true"
      style={{
        position: "absolute",
        ...POSITION_STYLES[config.position],
        color: "#ffffff",
        fontSize: config.fontSize,
        fontWeight: 600,
        letterSpacing: "0.01em",
        textShadow:
          "0 1px 3px rgba(0,0,0,0.85), 0 0 6px rgba(0,0,0,0.45)",
        opacity: config.opacity,
        pointerEvents: "none",
        userSelect: "none",
        maxWidth: "calc(100% - 16px)",
        whiteSpace: "nowrap",
        overflow: "hidden",
        textOverflow: "ellipsis",
        lineHeight: 1.2,
      }}
    >
      {text}
    </div>
  );
}
